import React, { useRef, useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import Sidenav from "../components/Sidenav";
import "../Console.css";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const IrisInvoice = ({ domain }) => {
  const invoiceRef = useRef();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [orderId, setOrderId] = useState(null);

  useEffect(() => {
    // prevent right‑click
    const handleContextMenu = (e) => e.preventDefault();
    window.addEventListener("contextmenu", handleContextMenu);
    return () => window.removeEventListener("contextmenu", handleContextMenu);
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const id = params.get("order");
    setOrderId(id);

    if (id) {
      (async () => {
        try {
          const response = await fetch(
            `https://api.iriscrypt.com/order/${id}`,
            {
              method: "GET",
              headers: { "x-api-key": "f87f030d-eaf4-4a39-9d5d-c9ffdb90ab43" },
            },
          );
          const result = await response.json();
          setOrder(result);
        } catch (error) {
          console.error("Failed to fetch order:", error);
        } finally {
          setLoading(false);
        }
      })();
    } else {
      console.warn("No order ID provided in URL.");
      setLoading(false);
    }
  }, []);

  const handleDownload = async () => {
    if (!invoiceRef.current || !order) return;
    const canvas = await html2canvas(invoiceRef.current, {
      scale: 2,
      useCORS: true,
    });
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("p", "mm", "a4");
    const pageWidth = pdf.internal.pageSize.getWidth();
    const imgProps = pdf.getImageProperties(imgData);
    const pdfHeight = (imgProps.height * pageWidth) / imgProps.width;
    pdf.addImage(imgData, "PNG", 0, 0, pageWidth, pdfHeight);
    pdf.save(`iris-invoice-${order.minSerial}.pdf`);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  // Pricing logic
  let unitCost = 0;
  let additionalCharge = 0;
  let subTotal = 0;
  let totalAmount = 0;
  if (order) {
    const purpose = order.metadata.purpose?.toLowerCase() || "";
    if (purpose === "demo") {
      unitCost = 0;
      additionalCharge = 0;
    } else {
      const isCustom = order.metadata.type?.toLowerCase() === "custom";
      unitCost = isCustom ? 5 : 4;
      additionalCharge = isCustom ? 150000 : 0;
    }
    subTotal = order.quantity * unitCost;
    totalAmount = subTotal + additionalCharge;
  }

  return (
    <>
      <Helmet>
        <title>Invoice | BLEEP</title>
      </Helmet>

      <div className="d-flex">
        <Sidenav domain={domain} />
        <div
          style={{
            flex: 1,
            position: "relative",
            height: "calc(100vh - 94px)",
            overflowY: "auto",
          }}
        >
          {/* Header */}
          <header
            style={{
              position: "relative",
              paddingInline: "30px",
              paddingBlock: "30px",
              color: "#fff",
              background:
                "linear-gradient(135deg, rgba(255,81,0,1) 0%, rgba(255,153,1,1) 100%)",
              overflow: "hidden",
            }}
          >
            <div
              aria-hidden
              style={{
                position: "absolute",
                inset: 0,
                backgroundImage: "url('/images/background-art.jpg')",
                backgroundRepeat: "repeat",
                backgroundSize: "400px 400px",
                backgroundPosition: "center",
                mixBlendMode: "overlay",
                opacity: 0.08,
                zIndex: 0,
                pointerEvents: "none",
              }}
            />
            <div
              style={{
                position: "relative",
                zIndex: 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 16,
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
                <button
                  onClick={() => window.history.back()}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 7,
                    background: "rgba(255,255,255,0.18)",
                    border: "1.5px solid rgba(255,255,255,0.35)",
                    color: "#fff",
                    borderRadius: 10,
                    padding: "8px 16px",
                    fontWeight: 700,
                    fontSize: 13,
                    cursor: "pointer",
                    backdropFilter: "blur(4px)",
                    flexShrink: 0,
                  }}
                >
                  <i
                    className="fa-solid fa-arrow-left"
                    style={{ fontSize: 12 }}
                  />
                  Back
                </button>
                <div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 10,
                      marginBottom: 4,
                    }}
                  >
                    <i
                      className="fa-solid fa-file-invoice-dollar"
                      style={{
                        fontSize: 22,
                        filter: "drop-shadow(1px 2px 0px #1c1c1c)",
                      }}
                    />
                    <b
                      style={{
                        fontSize: 26,
                        textShadow: "#1c1c1c 1px 2px 0px",
                        lineHeight: 1.1,
                      }}
                    >
                      IRIS Invoice
                    </b>
                  </div>
                  <div
                    style={{
                      fontSize: 13,
                      color: "rgba(255,255,255,0.85)",
                      textShadow: "#1c1c1c 1px 1px 0px",
                      paddingLeft: 2,
                    }}
                  >
                    Tag Order Invoice — IrisCrypt Inc.
                  </div>
                </div>
              </div>
              {order && (
                <button
                  onClick={handleDownload}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    background: "#fff",
                    border: "none",
                    color: "#c13d00",
                    borderRadius: 30,
                    padding: "10px 22px",
                    fontWeight: 700,
                    fontSize: 14,
                    cursor: "pointer",
                    boxShadow: "rgba(0,0,0,0.25) 0px 3px 8px",
                    flexShrink: 0,
                  }}
                >
                  <i
                    className="fa-solid fa-download"
                    style={{ fontSize: 13 }}
                  />
                  Download PDF
                </button>
              )}
            </div>
          </header>

          {/* Body */}
          <div
            style={{
              padding: "20px",
              backgroundColor: "#f3f4f6",
              display: "flex",
              justifyContent: "center",
            }}
          >
            {loading ? (
              <div>Loading...</div>
            ) : !orderId ? (
              <div style={{ color: "red" }}>No order ID provided in URL.</div>
            ) : order ? (
              <div
                ref={invoiceRef}
                style={{
                  width: "21cm",
                  minHeight: "29.7cm",
                  background: "white",
                  padding: "40px",
                  fontFamily: "Arial, sans-serif",
                  fontSize: "12pt",
                  color: "#333",
                }}
              >
                {/* Logo & Company */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "30px",
                  }}
                >
                  <img
                    src="/images/iris_logo_dark.png"
                    alt="IrisCrypt Logo"
                    style={{ height: "150px" }}
                  />
                  <div style={{ textAlign: "right" }}>
                    <b>IrisCrypt Inc.</b>
                    <br />
                    Toronto, Canada
                  </div>
                </div>

                {/* Addresses */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "30px",
                  }}
                >
                  <div>
                    <b>BILL TO:</b>
                    <br />
                    Bleep Security Tags Limited
                    <br />
                    Anti-Counterfeit Network Africa
                    <br />
                    Plot 40, Nakasero Road, Kampala, Uganda
                  </div>
                  <div style={{ textAlign: "right" }}>
                    <b>INVOICE DATE:</b> {formatDate(order.timestamp)}
                    <br />
                    <b>INVOICE #:</b> IRIS-{order._id.slice(-6)}
                  </div>
                </div>

                <hr style={{ margin: "20px 0" }} />

                {/* Details Table */}
                <table
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    marginBottom: "20px",
                  }}
                >
                  <tbody>
                    <tr>
                      <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                        <b>Tag Type</b>
                      </td>
                      <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                        {order.metadata.type}
                      </td>
                      <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                        <b>Serial Range</b>
                      </td>
                      <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                        {order.minSerial} - {order.maxSerial}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                        <b>Length</b>
                      </td>
                      <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                        {order.metadata.length}mm
                      </td>
                      <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                        <b>Quantity</b>
                      </td>
                      <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                        {order.quantity}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                        <b>Purpose</b>
                      </td>
                      <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                        {order.metadata.purpose.charAt(0).toUpperCase() +
                          order.metadata.purpose.slice(1)}
                      </td>
                      <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                        <b>Description</b>
                      </td>
                      <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                        {order.metadata.description}
                      </td>
                    </tr>
                    {/* Unit Cost & Subtotal */}
                    <tr>
                      <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                        <b>Unit Cost</b>
                      </td>
                      <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                        {unitCost.toLocaleString()} UGX
                      </td>
                      <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                        <b>Subtotal</b>
                      </td>
                      <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                        {subTotal.toLocaleString()} UGX
                      </td>
                    </tr>
                    {/* Additional Charge */}
                    <tr>
                      <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                        <b>Design Charges</b>
                      </td>
                      <td
                        colSpan={3}
                        style={{ padding: "10px", border: "1px solid #ddd" }}
                      >
                        {additionalCharge.toLocaleString()} UGX
                      </td>
                    </tr>
                  </tbody>
                </table>

                {/* Total */}
                <div style={{ textAlign: "right", marginTop: "30px" }}>
                  <h4 style={{ margin: 0 }}>
                    TOTAL AMOUNT: {totalAmount.toLocaleString()} UGX
                  </h4>
                </div>

                <hr style={{ margin: "30px 0" }} />

                {/* Footer */}
                <div
                  style={{
                    textAlign: "center",
                    fontSize: "10pt",
                    color: "#555",
                    marginTop: "40px",
                  }}
                >
                  Thank you for your business!
                </div>
              </div>
            ) : (
              <div style={{ color: "red" }}>Error loading order data.</div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default IrisInvoice;
